export default __webpack_public_path__ + "static/media/undraw_personal_finance_tqcd.33521af1.png";